import { z } from "zod";

export const LoginRequestSchema = z.strictObject({
  appKey: z.string().regex(/\S/),
});

export type LoginRequest = z.infer<typeof LoginRequestSchema>;
